import { t } from "@lingui/macro";

export const GPT_TEXT_LENGHT_PRESETS = [
  {
    id: "short",
    getDisplayName: () => t`__ficture.gpt_text_length_preset.short`,
  },
  {
    id: "medium",
    getDisplayName: () => t`__ficture.gpt_text_length_preset.medium`,
  },
  {
    id: "long",
    getDisplayName: () => t`__ficture.gpt_text_length_preset.long`,
  },
] as const;
